// Lightweight i18n for Skyline Retreat — RO (default) + EN

export const translations = {
  ro: {
    nav: {
      cabins: "Cabane",
      reviews: "Recenzii",
      location: "Locație",
      contact: "Contact",
    },
    hero: {
      eyebrow: "Mătișești · Munții Apuseni",
      title: "Skyline Retreat",
      subtitle:
        "Două cabane primitoare, cu priveliști care îți taie respirația — locul tău de evadare din liniștea Apusenilor.",
      cta: "Vezi disponibilitate",
      scroll: "Descoperă cabanele",
    },
    cabins: {
      heading: "Alege cabana ta",
      sub: "Două experiențe, același peisaj de vis. Apasă pe tab-uri pentru a explora fiecare cabană.",
    },
    cabin: {
      s1_name: "Cabana S1",
      s1_tag: "A‑Frame · cozy pentru cuplu",
      s1_desc:
        "Cabană în stilul A‑Frame, amenajată cu mult bun gust, cu terasă din lemn, șezlonguri și priveliște panoramică. Liniștea pădurii și răsăriturile din mansardă fac fiecare dimineață memorabilă. Notă: cabana era cunoscută anterior sub numele „Cabana dintre Mesteceni” — acum face parte din Skyline Retreat.",
      s2_name: "Cabana S2",
      s2_tag: "Chalet · ideală pentru familii",
      s2_desc:
        "Chalet pe două nivele, cu mansardă spațioasă, balcon larg și ciubăr exterior. Geamuri panoramice de la podea la tavan, leagăn suspendat și un peisaj montan care nu te lasă să pleci.",
      features: "Ce găsești aici",
      gallery: "Galerie",
      availability: "Verifică disponibilitatea",
      pickDates: "Alege perioada dorită",
      pickHint: "Apasă pe data de check‑in, apoi pe data de check‑out.",
      selected: "Perioadă selectată",
      nights: "nopți",
      night: "noapte",
      contactNow: "Contactează proprietarul",
      reset: "Resetează",
      pleasePick: "Selectează mai întâi perioada în calendar.",
    },
    features: {
      s1: [
        "Capacitate 2+1 persoane",
        "Pet friendly · animalele acceptate",
        "Terasă cu șezlonguri",
        "Priveliște panoramică",
        "Mansardă cu vedere",
        "Loc de grătar",
        "Parcare privată",
        "WiFi & Smart TV",
      ],
      s2: [
        "Capacitate 2+1 persoane",
        "Nu este pet friendly",
        "Ciubăr exterior",
        "Mansardă spațioasă",
        "Balcon panoramic",
        "Living cu geam panoramic",
        "Pat king‑size",
        "Bucătărie complet utilată",
      ],
    },
    booking: {
      title: "Cum dorești să contactezi proprietarul?",
      desc: "Mesajul va conține perioada selectată. Răspuns rapid garantat.",
      messagePreview: "Previzualizare mesaj",
      sms: "Trimite SMS",
      call: "Sună acum",
      cancel: "Anulează",
      copy: "Copiază mesajul",
      copied: "Mesaj copiat!",
    },
    reviews: {
      heading: "Ce spun oaspeții noștri",
      sub: "48 de recenzii pe Google · 5,0 ★",
      seeAll: "Vezi toate recenziile",
      ago: {
        week: "acum 2 săptămâni",
        month: "acum o lună",
        twoMonths: "acum 2 luni",
        threeMonths: "acum 3 luni",
      },
    },
    location: {
      heading: "Unde ne găsești",
      sub: "Sat Mătișești, comuna Horea, județul Alba — în inima Munților Apuseni.",
      drive: "Deschide în Google Maps",
      address: "Strada Principală Horea nr. 387, Sat Mătișești, 517340, Alba",
    },
    footer: {
      tagline: "Două cabane. O priveliște de neuitat.",
      rights: "Toate drepturile rezervate.",
      contact: "Contact direct",
    },
    msgTemplate: (cabin, from, to) =>
      `Salut, este disponibilă cabana ${cabin} în perioada ${from} - ${to}? Mulțumesc.`,
  },
  en: {
    nav: {
      cabins: "Cabins",
      reviews: "Reviews",
      location: "Location",
      contact: "Contact",
    },
    hero: {
      eyebrow: "Mătișești · Apuseni Mountains",
      title: "Skyline Retreat",
      subtitle:
        "Two welcoming cabins with breathtaking views — your escape into the silence of the Apuseni.",
      cta: "Check availability",
      scroll: "Discover the cabins",
    },
    cabins: {
      heading: "Choose your cabin",
      sub: "Two experiences, one dreamy landscape. Switch tabs to explore each cabin.",
    },
    cabin: {
      s1_name: "Cabin S1",
      s1_tag: "A‑Frame · cozy for couples",
      s1_desc:
        "A‑Frame style cabin, tastefully furnished, with a wooden deck, loungers and panoramic views. The forest silence and sunrises from the attic make every morning unforgettable. Note: this cabin was previously known as „Cabana dintre Mesteceni” — it is now part of Skyline Retreat.",
      s2_name: "Cabin S2",
      s2_tag: "Chalet · perfect for families",
      s2_desc:
        "Two‑level chalet with a spacious loft, wide balcony and outdoor hot tub. Floor‑to‑ceiling panoramic windows, a hanging swing, and a mountain landscape that won't let you leave.",
      features: "What you'll find here",
      gallery: "Gallery",
      availability: "Check availability",
      pickDates: "Pick your dates",
      pickHint: "Tap the check‑in date, then the check‑out date.",
      selected: "Selected period",
      nights: "nights",
      night: "night",
      contactNow: "Contact the owner",
      reset: "Reset",
      pleasePick: "Please pick a date range first.",
    },
    features: {
      s1: [
        "Sleeps 2+1 guests",
        "Pet friendly · pets welcome",
        "Deck with loungers",
        "Panoramic view",
        "Attic with view",
        "BBQ area",
        "Private parking",
        "WiFi & Smart TV",
      ],
      s2: [
        "Sleeps 2+1 guests",
        "No pets allowed",
        "Outdoor hot tub",
        "Spacious loft",
        "Panoramic balcony",
        "Living with panoramic glass",
        "King‑size bed",
        "Fully equipped kitchen",
      ],
    },
    booking: {
      title: "How would you like to reach the owner?",
      desc: "The message includes your selected period. Quick reply guaranteed.",
      messagePreview: "Message preview",
      sms: "Send SMS",
      call: "Call now",
      cancel: "Cancel",
      copy: "Copy message",
      copied: "Message copied!",
    },
    reviews: {
      heading: "What our guests say",
      sub: "48 Google reviews · 5.0 ★",
      seeAll: "See all reviews",
      ago: {
        week: "2 weeks ago",
        month: "1 month ago",
        twoMonths: "2 months ago",
        threeMonths: "3 months ago",
      },
    },
    location: {
      heading: "Where to find us",
      sub: "Mătișești village, Horea commune, Alba county — in the heart of the Apuseni Mountains.",
      drive: "Open in Google Maps",
      address: "Strada Principală Horea no. 387, Mătișești, 517340, Alba",
    },
    footer: {
      tagline: "Two cabins. One unforgettable view.",
      rights: "All rights reserved.",
      contact: "Direct contact",
    },
    msgTemplate: (cabin, from, to) =>
      `Hello, is cabin ${cabin} available between ${from} - ${to}? Thank you.`,
  },
};

export const useT = (lang) => translations[lang] || translations.ro;
;
